const URL_API = '/downloads'

export default ($axios) => ({
  downloadAnexo(siglaEmpresa, modulo, uuid) {
    return $axios.get(`${URL_API}/${siglaEmpresa}/anexos/${modulo}/${uuid}`, {
      responseType: 'blob',
    })
  },
})
